import { Button, Checkbox as ChakraCheckbox, HStack, Switch, Text } from '@chakra-ui/react'
import { ThemeContext } from '@hb/react'
import { CheckboxField } from '@hb/shared'
import * as React from 'react'
import { useContext } from 'react'
import { InputProps } from '../../../../types/fields'
import { getInputSizeTokens, useInputSize } from '../Shared/sizes'

const Checkbox: React.FC<InputProps<CheckboxField> & { readOnly?: boolean }> = ({
  field,
  input,
  readOnly,
  size: sizeProp,
  disabled,
}) => {
  const { placeholder, inputType } = field ?? {}
  const { inputSize: ctxInputSize } = useContext(ThemeContext)
  // An explicit size (prop / field.size / form-wide context) opts a switch into the size-token
  // control sizing. Switches otherwise default to the compact Chakra 'sm' control.
  const explicitSize = sizeProp ?? field.size ?? ctxInputSize
  const size = useInputSize(explicitSize)
  const tokens = getInputSizeTokens(size)
  const isLarge = size === 'md' || size === 'lg'
  const switchSize = explicitSize ? tokens.checkboxSize : 'sm'
  const checkboxSize = tokens.checkboxSize
  return inputType === 'switch' ? (
    <HStack w="100%" px={isLarge ? 1 : 0} align="center">
      <Button
        display="flex"
        flexFlow="row"
        w="100%"
        height="auto"
        // py={0.5}
        pt={inputType === 'switch' ? 1 : 0}
        gap={isLarge ? 2 : 1.5}
        variant="unstyled"
        onClick={() => input.onChange(!input.value)}>
        <Switch
          // px={1}
          onFocus={input.onFocus}
          onBlur={input.onBlur}
          size={switchSize}
          pointerEvents="none"
          colorScheme="green"
          isChecked={input.value}
        />
        <Text
          flex={1}
          minW={0}
          whiteSpace="pre-wrap"
          textAlign="left"
          fontFamily="Hero-New"
          fontWeight={400}
          fontSize={tokens.placeholderFontSize}
          color="#333333">
          {input.value ? (field.yesText ?? placeholder) : (field.noText ?? placeholder)}
        </Text>
      </Button>
    </HStack>
  ) : (
    <ChakraCheckbox
      px={1}
      // my={1}
      mt={1}
      readOnly={readOnly}
      isDisabled={disabled}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      size={checkboxSize}
      colorScheme="green"
      onChange={({ target: { checked } }) => {
        input.onChange(checked)
        input.onBlur()
      }}
      isChecked={input.value}>
      <Text
        fontWeight={400}
        fontSize={tokens.placeholderFontSize}
        color="#333333"
        fontFamily="Hero-New">
        {field.placeholder}
      </Text>
    </ChakraCheckbox>
  )
}

export default Checkbox
